export const getSubstringInBraces = (str: string) => {
  const regex = /{([^{}]*)}/ // match anything between braces {}
  const match = regex.exec(str)
  if (match) {
    return match[1] // return the text between the braces
  }
  return null
}
